import { OperatorApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { Operator } from './types';

export const normalizeOperators = (data: OperatorApi[]): Operator[] =>
  data.map((d) => normalizeOperator(d));

export const normalizeOperator = (row: OperatorApi): Operator => {
  return { ...row, uuid: uuidv4() };
};
